import mapDocument from "../utils/mapDocument";

export default async function getCollectionData(ref) {
	const list = [];

	(await ref.get()).forEach((doc) => list.push(mapDocument(doc)));

	return list;
}
